<template>
  <section>
    <div id="asset-tracking-system">
      <ul class="tabs-container">
        <li v-for="(tab, index) in tabs" :key="index" :class="{ active: activeTab === index }" @click="activeTab = index">
          {{ tab }}
        </li>
      </ul>
      <div v-show="activeTab === 0">
        <h4 class="margin-h4">MONITOR YOUR ASSETS</h4>
        <p class="margin-p">
          Automize the tracking of your assets through AYUN!, an asset
          monitoring system that uses QR CODES and CLOUD TECHNOLOGY to transfer
          and track the accountability of Returnable Packaging Equipment (RPE)
          within the supply chain.
        </p>
        <p class="know-more">
          To know more about asset movement monitoring.
          <a href="/#contact-us" class="learn-more">LEARN MORE</a>
        </p>
      </div>
      <div v-show="activeTab === 1">
        <h4 class="margin-h4">TRACK YOUR ASSETS</h4>
        <p class="margin-p">
          AYUN! Inventory can help you manage your business inventory and keep
          track of exactly where your assets are.
        </p>
        <p class="know-more">
          To know more about asset movement monitoring.
          <a href="/#contact-us" class="learn-more">LEARN MORE</a>
        </p>
      </div>
      <div v-show="activeTab === 2">
        <h4 class="margin-h4">SAVE MORE TIME IN INVENTORY CHECKING</h4>
        <p class="margin-p">
          Automate the tracking of your assets through Ayun! Asset-Based, an
          asset monitoring system that uses QR CODES and CLOUD TECHNOLOGY to
          transfer and track the accountability of Returnable Packaging
          Equipment (RPE) within the supply chain. Ayun! AB has fixed asset
          monitoring in multiple locations, both online and offline.
        </p>
        <p class="know-more">
          To know more about asset movement monitoring.
          <a href="/#contact-us" class="learn-more">REQUEST A DEMO</a>
        </p>
      </div>
      <div v-show="activeTab === 3">
        <h4 class="margin-h4">USER VISIBILITY RESTRICTIONS</h4>
        <p class="margin-p">
          Automate the tracking of your fast-moving assets through Ayun!
          Quantity-Based, an asset monitoring system that is capable of
          monitoring multiple returnable moving assets and uses SECURED CLOUD
          TECHNOLOGY to transfer and track the accountability of Returnable
          Packaging Equipment (RPE) within the supply chain.
        </p>
        <p class="know-more">
          To know more about asset movement monitoring.
          <a href="/#contact-us" class="learn-more">REQUEST A DEMO</a>
        </p>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  data() {
    return {
      tabs: [
        "ASSET MOVEMENT MONITORING",
        "FIXED ASSET INVENTORY",
        "AYUN ASSET-BASED",
        "AYUN QUANTITY-BASED",
      ],
      activeTab: 0,
    };
  },
};
</script>

<style>
@import url("https://fonts.googleapis.com/css2?family=Old+Standard+TT&family=Poppins:wght@800&display=swap");

div[id="asset-tracking-system"] ul {
  list-style-type: none;
}

div[id="asset-tracking-system"] ul li {
  display: inline-block;
  padding: 10px 20px;
  cursor: pointer;
  font-family: "Poppins";
  font-weight: 700;
  font-size: 20px;
  color: #a7a5a1;
  margin-top: 30px;
}

div[id="asset-tracking-system"] ul li.active {
  color: #122b90;
}

div[id="asset-tracking-system"] ul li:hover {
  color: #122b90;
}

div[id="asset-tracking-system"] p {
  font-family: "Poppins";
  font-weight: 500;
  color: #343434;
}

div[id="asset-tracking-system"] p.margin-p {
  margin-left: 50px;
  margin-right: 50px;
}

div[id="asset-tracking-system"] h4 {
  font-family: "Poppins";
  font-weight: 600;
  color: #122b90;
}

div[id="asset-tracking-system"] h4.margin-h4 {
  margin-left: 50px;
  margin-right: 50px;
}

div[id="asset-tracking-system"] .know-more {
  font-weight: 700;
  color: #343434;
  margin-left: 50px;
  margin-right: 50px;
  margin-bottom: 50px;
}

div[id="asset-tracking-system"] .learn-more {
  text-decoration: none;
  color: #122b90;
  font-weight: 700;
  margin-left: 5px;
}

div[id="asset-tracking-system"] .learn-more:hover {
  color: #122b90;
}

.tabs-container {
  text-align: center;
  margin-top: -30px;
}</style>
